import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { showError } from '../../constants/toasts';
import MainContainer from '../../layout/MainContainer';
import { useLazyGetPromoCodeByIdQuery } from '../../service/promoCode';
const PromoCodeDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [getPromoById] = useLazyGetPromoCodeByIdQuery();
  const [loading, setLoading] = useState(false);
  interface PromoCodeDetails {
    name?: string;
    discountPrice?: number;
  }

  const [Details, setDetails] = useState<PromoCodeDetails | null>(null);

  const getListingDetail = async (id: string) => {
    setLoading(true);
    try {
      const response = await getPromoById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setDetails(response?.data);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      getListingDetail(id);
    }
  }, []);

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>Promo Code Detail</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> -{' '}
            <span onClick={() => navigate('/manage-promo-codes')}>Promo Codes</span> - Promo Code
            Detail
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards profile_top">
        <div className="gap_p">
          <div className="left_s">
            <div className="details_vw">
              <div className="w_50">
                {' '}
                <h3>Promo Code Name</h3>
                <p>{Details?.name || '-'}</p>
              </div>
              <div className="w_50">
                {' '}
                <h3>Discount</h3>
                <p>{Details?.discountPrice}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Box className="custom_tabs2" sx={{ width: '100%' }}></Box>

      <div className="cards">
        <div className="profileInfo_head">
          <h2>Users List</h2>
        </div>

        <div className="shipping_img">
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table className="v2" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>User Image</TableCell>
                  <TableCell>User Email</TableCell>
                  <TableCell>Phone Number</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell>
                    <div className="user_block">
                      <figure>
                        <img src="/static/images/user_attachment.jpg" alt="" />
                      </figure>
                      <p>
                        <b>Emma Smith</b>
                      </p>
                    </div>
                  </TableCell>
                  <TableCell>emma@gmail.com</TableCell>
                  <TableCell>+9203024595467</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </MainContainer>
  );
};

export default PromoCodeDetail;
